<template>
  <b-modal :active="show" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit Location Contact</p>
      </header>
      <section class="modal-card-body">

        <contact-form v-model="updatedContact"
                      :remove-key-on-update="false"
                      :can-search="false"
        />

      </section>
      <footer class="modal-card-foot columns">
        <div class="column is-one-third">
          <button class="button" type="button" @click="close" >Cancel</button>
          <button class="button" type="button" @click="save" :class="{ 'is-loading': isSaving }" >Save</button>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import contactToRolodex from '@/helpers/convertContactToRolodex'
import RolodexApi from '@/api-interface/rolordex'

import ContactForm from '@/components/FormContact'

export default {
  name: 'RolodexContactEdit',

  props: {
    show: {
      type: Boolean,
      required: true
    },
    contact: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      updatedContact: {},
      isSaving: false
    }
  },

  components: {
    ContactForm
  },

  computed: {
    payload() {
      return contactToRolodex(this.updatedContact)
    }
  },

  methods: {
    close() {
      this.$emit('update:show', false)
    },

    async save() {
      this.isSaving = true
      try {
        await RolodexApi.updateContact(this.payload)
      } catch (error) {
        console.error('Unable to update contact', error)
      } finally {
        this.isSaving = false
        this.$emit('updated')
        this.close()
      }
    },

    copyPropToData() {
      const contact = Object.assign({}, this.contact)

      this.updatedContact = {
        ...contact,
        name: contact.companyRolodexContactFullName,
        email: contact.companyRolodexContactEmailAddress,
        phone: contact.companyRolodexContactPhones[0]
          ? contact.companyRolodexContactPhones[0].companyRolodexContactPhoneDigits
          : ''
      }
    }
  },

  watch: {
    show() {
      if (this.show) {
        this.copyPropToData()
      }
    }
  }
}
</script>

<style scoped>
.modal-card {
  width: 960px;
}
</style>
